import { render } from "./DownloadGemini.vue?vue&type=template&id=63bd3cce"
import script from "./DownloadGemini.vue?vue&type=script&lang=js"
export * from "./DownloadGemini.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__